import { useEffect, useState } from 'react';

import { formatMessage } from '~/common/helpers/formatMessage';
import withHooks from '~/common/hoc/withHooks';

const enhancer = withHooks(({ log }: { log: { logMessage?: string } }) => {
  const [logMessage, setLogMessage] = useState(formatMessage(log?.logMessage));

  useEffect(() => {
    const formattedMessage = formatMessage(log?.logMessage);
    setLogMessage(formattedMessage);
  }, [log?.logMessage]);

  const state = {
    logMessage
  };

  return state;
});

export default enhancer;
